import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../assets/css/Cookie-Richtlinien.css';

const CookiePolicyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="cookie-policy-page">
      {/* Hero Section */}
      <header className="tcx-hero">
        <div className="container text-center">
          <h1 className="tcx-hero__title">{t('cookiePolicy.hero.title')}</h1>
          <p className="tcx-hero__subtitle">{t('cookiePolicy.hero.subtitle')}</p>
        </div>
      </header>

      <main className="py-5">
        <div className="container">
          {/* Section 1: What are Cookies? */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.whatAreCookies.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.whatAreCookies.content')}</p>
              </div>
            </div>
          </section>

          {/* Section 2: Cookie Types */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.cookieTypes.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.cookieTypes.content')}</p>
                <ul>
                  {t('cookiePolicy.sections.cookieTypes.list', { returnObjects: true }).map((item, index) => (
                    <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                  ))}
                </ul>
              </div>
            </div>
          </section>

          {/* Section 3: Necessary Cookies */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.necessaryCookies.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.necessaryCookies.content')}</p>
              </div>
            </div>
          </section>

          {/* Section 4: Functional & Analytics Cookies */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.functionalAnalyticsCookies.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.functionalAnalyticsCookies.content')}</p>
              </div>
            </div>
          </section>

          {/* Section 5: Marketing Cookies */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.marketingCookies.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.marketingCookies.content')}</p>
              </div>
            </div>
          </section>

          {/* Section 6: Third-Party Cookies */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.thirdPartyCookies.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.thirdPartyCookies.content')}</p>
              </div>
            </div>
          </section>

          {/* Section 7: Manage Cookies */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.manageCookies.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.manageCookies.content')}</p>
              </div>
            </div>
          </section>

          {/* Section 8: Your Rights */}
          <section className="mb-5">
            <h2 className="section-title">{t('cookiePolicy.sections.yourRights.title')}</h2>
            <div className="tcx-card card">
              <div className="card-body">
                <p>{t('cookiePolicy.sections.yourRights.content')}</p>
                <ul>
                  {t('cookiePolicy.sections.yourRights.list', { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p>
                  {t('cookiePolicy.sections.yourRights.contact')}
                  <a href={`mailto:${t('cookiePolicy.sections.yourRights.email')}`}>
                    {t('cookiePolicy.sections.yourRights.email')}
                  </a>
                </p>
              </div>
            </div>
          </section>

          {/* Last Updated */}
          <section>
            <p className="text-muted small">{t('cookiePolicy.lastUpdated')}</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default CookiePolicyPage;